var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fullview"},[_c('div',{staticClass:"loading-spacer"}),_c('vue-loading',{attrs:{"type":"spin","color":"#DCC268","size":{ width: '50px', height: '50px' }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }